module.exports = __webpack_public_path__ + "media/type2(rare).883fdb20.mp4";